document.addEventListener("DOMContentLoaded", function() {

  const MAIN_PRODUCT_ID = 1234567890;
  const SERVICE_IDS = [1111111111, 2222222222]; 


  function syncServices(cart) {
    const mainItem = cart.items.find(i => i.product_id === MAIN_PRODUCT_ID);
    if (!mainItem) return; 

    const mainQty = mainItem.quantity;

    cart.items.forEach(item => {
      if (SERVICE_IDS.includes(item.product_id)) {
        let desiredQty = Math.min(item.quantity, mainQty);

        if (item.quantity !== desiredQty) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: desiredQty
            })
          })
          .then(res => res.json())
          .then(newCart => {
            console.log("Services synced:", newCart);
            updateCartUI(newCart); 
          });
        }
      }
    });
  }


  function fetchCartAndSync() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => syncServices(cart));
  }


  function updateCartUI(cart) {

    console.log("Cart updated:", cart);
  }


  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="updates[]"], .cart__qty-input')) {

      setTimeout(fetchCartAndSync, 600);
    }
  });

  fetchCartAndSync();

  /**
   * Long product landing page fixes
   * - Prevent scroll-trigger from hiding sections (opacity 0.01 when offscreen)
   * - Improve image lazy loading reliability for long landing pages / sliders
   *
   * Historically observed on:
   * - /products/custom-pet-plush
   * - /products/custom-golf-club-headcover
   */
  try {
    const pathname =
      window.location && typeof window.location.pathname === "string"
        ? window.location.pathname
        : "";

    const isAffectedByPath =
      pathname.indexOf("/products/custom-pet-plush") === 0 ||
      pathname.indexOf("/products/custom-golf-club-headcover") === 0;

    // Fallback: in case the product handle differs but template suffix matches.
    // (Body class pattern: template-product--<template.suffix>)
    const isAffectedByTemplateClass =
      document.body &&
      document.body.classList &&
      (document.body.classList.contains("template-product--custom-golf-club") ||
        document.body.classList.contains("template-product--golf-headcover-temp") ||
        document.body.classList.contains("template-product--custom-golf-club-headcover"));

    const shouldApplyFixes = isAffectedByPath || isAffectedByTemplateClass;

    if (shouldApplyFixes) {
      const removeOffscreen = (root = document) => {
        root.querySelectorAll(".scroll-trigger--offscreen").forEach((el) => {
          el.classList.remove("scroll-trigger--offscreen");
        });
      };

      const forceEagerAndUnveil = (root = document) => {
        root.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          // Avoid native lazyload edge-cases on long pages
          img.loading = "eager";
        });

        // Ensure responsive sources are applied even if lazysizes misses a cycle
        root.querySelectorAll("img.lazyload[data-srcset]").forEach((img) => {
          if (!img.getAttribute("srcset")) {
            img.setAttribute("srcset", img.getAttribute("data-srcset"));
          }
          const dataSizes = img.getAttribute("data-sizes");
          if (dataSizes && !img.getAttribute("sizes")) {
            img.setAttribute("sizes", dataSizes);
          }
        });

        if (window.lazySizes && window.lazySizes.loader) {
          window.lazySizes.loader.checkElems();
        }
      };

      // Initial pass
      removeOffscreen();
      forceEagerAndUnveil();

      // Keep fixing as dynamic sliders/sections render
      const mo = new MutationObserver((mutations) => {
        let shouldRecheck = false;

        for (const m of mutations) {
          if (m.type === "attributes" && m.attributeName === "class") {
            const el = m.target;
            if (el && el.classList && el.classList.contains("scroll-trigger--offscreen")) {
              el.classList.remove("scroll-trigger--offscreen");
            }
            continue;
          }

          if (m.type === "childList" && m.addedNodes && m.addedNodes.length) {
            shouldRecheck = true;
          }
        }

        if (shouldRecheck) {
          removeOffscreen();
          forceEagerAndUnveil();
        }
      });

      mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      // Recheck after load + a few scrolls (covers late init sliders)
      window.addEventListener("load", () => {
        removeOffscreen();
        forceEagerAndUnveil();
      });
      let rafScheduled = false;
      window.addEventListener(
        "scroll",
        () => {
          if (rafScheduled) return;
          rafScheduled = true;
          requestAnimationFrame(() => {
            rafScheduled = false;
            removeOffscreen();
            forceEagerAndUnveil();
          });
        },
        { passive: true }
      );
    }
  } catch (e) {
    // Never break the storefront due to this helper
    console.warn("[kik-custom] custom-pet-plush fixes failed", e);
  }

  try {
    const PAYPAL_MESSAGE_SELECTOR = "[data-paypal-pay-later-message]";
    const PAYPAL_VARIANTS_SELECTOR = "[data-paypal-pay-later-variants]";
    const PRODUCT_MESSAGE_SELECTOR =
      '[data-paypal-pay-later-message][data-paypal-page-type="product-details"]';
    const VARIANT_INPUT_SELECTOR = "[data-product-form-variant]";
    const PAYPAL_RENDER_STYLE = {
      layout: "text",
      logo: {
        type: "inline",
      },
      text: {
        color: "black",
        size: 12,
      },
    };

    const isPayPalReady = () =>
      !!(window.paypal && typeof window.paypal.Messages === "function");

    const getRootMessages = (root) => {
      if (!root || !root.querySelectorAll) {
        return [];
      }

      const messages = [];

      if (root.matches && root.matches(PAYPAL_MESSAGE_SELECTOR)) {
        messages.push(root);
      }

      if (root.querySelectorAll) {
        messages.push(...root.querySelectorAll(PAYPAL_MESSAGE_SELECTOR));
      }

      return messages;
    };

    const getProductScope = (message) =>
      message.closest(".product__info") ||
      message.closest("#Quick-view") ||
      message.closest(".shopify-section") ||
      document;

    const getVariantPrices = (message) => {
      const scope = getProductScope(message);
      const payload = scope.querySelector(PAYPAL_VARIANTS_SELECTOR);

      if (!payload) {
        return null;
      }

      if (!payload._paypalVariantPrices) {
        try {
          payload._paypalVariantPrices = JSON.parse(payload.textContent);
        } catch (error) {
          console.warn("[kik-custom] failed to parse PayPal variant prices", error);
          payload._paypalVariantPrices = null;
        }
      }

      return payload._paypalVariantPrices;
    };

    const renderPayPalMessage = (message) => {
      if (!message || !isPayPalReady()) {
        return;
      }

      message.innerHTML = "";

      window.paypal
        .Messages({
          style: PAYPAL_RENDER_STYLE,
        })
        .render(message)
        .catch(() => {});
    };

    const syncProductMessageAmount = (message) => {
      const scope = getProductScope(message);
      const variantInput = scope.querySelector(VARIANT_INPUT_SELECTOR);
      const variantPrices = getVariantPrices(message);

      if (!variantInput || !variantPrices) {
        renderPayPalMessage(message);
        return;
      }

      const variantAmount = variantPrices[variantInput.value];

      if (variantAmount !== undefined && variantAmount !== null) {
        message.setAttribute("data-pp-amount", String(variantAmount));
      }

      renderPayPalMessage(message);
    };

    const bindProductMessageScope = (scope) => {
      if (!scope || scope.dataset.paypalPayLaterBound === "true") {
        return;
      }

      if (!scope.querySelector(PRODUCT_MESSAGE_SELECTOR)) {
        return;
      }

      scope.dataset.paypalPayLaterBound = "true";
      scope.addEventListener("change", (event) => {
        if (!event.target.closest("variant-picker")) {
          return;
        }

        window.setTimeout(() => {
          scope
            .querySelectorAll(PRODUCT_MESSAGE_SELECTOR)
            .forEach(syncProductMessageAmount);
        }, 0);
      });
    };

    const preparePayPalMessages = (root = document) => {
      const messages = getRootMessages(root);

      messages.forEach((message) => {
        if (message.dataset.paypalPageType === "product-details") {
          bindProductMessageScope(getProductScope(message));
          syncProductMessageAmount(message);
          return;
        }

        renderPayPalMessage(message);
      });
    };

    const observePayPalMessages = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) {
              return;
            }

            preparePayPalMessages(node);
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    preparePayPalMessages(document);
    observePayPalMessages();

    if (isPayPalReady()) {
      preparePayPalMessages(document);
    } else {
      window.addEventListener("petdaer:paypal-messages-ready", () => {
        preparePayPalMessages(document);
      });
    }
  } catch (error) {
    console.warn("[kik-custom] PayPal Pay Later init failed", error);
  }
});
